import { render, staticRenderFns } from "./EditNeighborhoodPage.vue?vue&type=template&id=521d3035&"
import script from "./EditNeighborhoodPage.vue?vue&type=script&lang=js&"
export * from "./EditNeighborhoodPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports